/**
 * Calculates the difference between two arrays.
 * Returns values of array 'a' that are not present in the array 'b'.
 * Supports duplicate values.
 * Inspired by https://stackoverflow.com/a/39811025
 */
export const diff = <T>(a: T[], b: T[]): T[] => {
  const entriesIndex = [
    ...Array.from(
      a.reduce(
        (acc, v) => acc.set(v, (acc.get(v) || 0) + 1),
        b.reduce(
          (acc: Map<T, number>, v) => acc.set(v, (acc.get(v) || 0) - 1),
          new Map(),
        ),
      ),
    ),
  ];
  return entriesIndex.reduce(
    (acc: T[], [v, count]) =>
      count > 0 ? acc.concat(Array<T>(count).fill(v)) : acc,
    [],
  );
};
